function initGrowingImage() {
	const growingImageContainer = document.querySelector( '.growing-img--container' );
	const growingImage = document.querySelector( '.growing-img' );

	if ( growingImageContainer && !growingImageContainer.classList.contains( 'enlarge' ) ) {
		window.addEventListener( 'scroll', ( event ) => {
			if ( document.documentElement.scrollTop > 0 ) {
				growingImageContainer.classList.add( 'enlarge' );
				growingImage.classList.add( 'enlarge' );
			} else {
				growingImageContainer.classList.remove( 'enlarge' );
				growingImage.classList.remove( 'enlarge' );
			}
		} );
	}
}

export default {
	init() {
		initGrowingImage();
	},
};